/* eslint-disable no-console */
// error が投げられず console.error に出力するだけの致命的なエラーは
// Sentryで通知することが難しいため、この関数を呼び出すことで検知できるようにする。
// e.g., React Maximum update depth exceeded エラー
// ユーザーが操作する画面で当該 alert は出せないので、利用環境は適宜 feature flag で制御する。
export const initSubtleErrorDetector = (): void => {
  const originalError = console.error;
  const customizedError: typeof console.error = (...args) => {
    originalError(...args);
    const [message] = args;
    if (
      typeof message === "string" &&
      message.includes("Maximum update depth exceeded")
    ) {
      alert(
        "Maximum update depth exceeded エラーが発生しています。コンポーネントの再レンダリングが無限ループに陥っている可能性があるのでコンソールを確認してください。",
      );
    }
  };
  console.error = customizedError;
};
